// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"148":"7a71a7b5","230":"5abf4bf3","237":"ffaa963b"}[chunkId] + ".css";
};